import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import { Background } from 'layout';
import { Box, Typography, Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import styles from './styles.module.css';
import cn from 'classnames';

const OnboardingSuccess = (props) => {
    const [copied, setCopied] = React.useState(false);
    const maskContactNumber = `xxx-xxx-${props?.metadata?.phone?.slice(-4)}`;
    const handleCopyLink = () => {
        setCopied(true);
        navigator.clipboard.writeText(props?.link);
        toast.success('Link copied to clipboard.', {
            theme: 'dark',
            autoClose: 2500,
            hideProgressBar: true,
        });
        setTimeout(() => setCopied(false), 2500);
    };
    return (
        <Background className={styles.successFormWrapper} wrapper={styles.wrapper}>
            <Card.Header as="h5" className={styles.cardHeader}>
                Verification Initiation
            </Card.Header>
            <Card.Body className={styles.cardbody}>
                <Typography className={cn(styles.text, styles.center)}>
                    A verification link has been sent to <b>{maskContactNumber}</b>.
                </Typography>
                <Box className={styles.linkWrapper}>
                    <a href={props?.link} className={styles.link}>
                        {props?.link}
                    </a>
                    <Button
                        variant="contained"
                        onClick={handleCopyLink}
                        className={styles.copyBtn}
                        disabled={copied}
                    >
                        Copy
                    </Button>
                </Box>
                <Typography className={cn(styles.text, styles.light)}>
                    Click the button above to copy the verification link or use it directly to
                    complete your verification.
                </Typography>
            </Card.Body>
            <Card.Footer className={styles.cardFooter}>
                <Typography className={styles.text}>
                    Results will be emailed to <b>{props?.metadata?.email}</b> post successful
                    verification.
                </Typography>
            </Card.Footer>
        </Background>
    );
};

OnboardingSuccess.propTypes = {
    metadata: PropTypes.object,
    link: PropTypes.string,
};

export default OnboardingSuccess;
